export const environment = {
    production: true,
    // apiUrl: 'https://divapi.visionforummah.org/api',
    // patchUrl: 'https://divapi.visionforummah.org',
    apiUrl: 'http://api.zar3.net/api',
    patchUrl: 'http://api.zar3.net',
};